import Api from '@/services/api';
import qs from 'querystring';

export default {
  get(ac, options) {
    return Api().post('/client/ac', qs.stringify(ac), options);
  },
}